import IcCheckmark from '@deliveryhero/pd-cookbook/components/Icons/IcCheckmark';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { FormikProps } from 'formik';
import HighlightAsterisks from 'src/components/HighlightAsterisks/HighlightAsterisks';

import ButtonList from '../../ButtonListSelect';
import { AllowanceValuesType } from '../AllowanceDetailForm';
import { AllowancePaddedPaper as PaddedPaper } from './AllowancePaddedPaper';
import { collectionTypeButtons, serviceTypeButtons } from './buttons';

export const SelectServiceType = ({
  values,
  setFieldValue
}: FormikProps<AllowanceValuesType>) => {
  return (
    <Grid item>
      <PaddedPaper title={'Select service type *'} disabled={!values.editable}>
        <Grid item xs={12}>
          <ButtonList
            buttons={serviceTypeButtons.map((b) => ({
              ...b,
              selected: values[b.id]
            }))}
            handleClick={(id) => {
              const selected = serviceTypeButtons.filter((b) => values[b.id]);
              !(selected.length === 1 && id === selected[0].id) &&
                setFieldValue(id, !values[id]);
            }}
            selectedIcon={<IcCheckmark style={{ fill: '#E21B70' }} />}
            disabled={!values.editable}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography type="title-md">
            <HighlightAsterisks
              text="Select collection type *"
              disabled={!values.editable}
            />
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ButtonList
            buttons={collectionTypeButtons.map((b) => ({
              ...b,
              selected: values[b.id]
            }))}
            handleClick={(id) => {
              const selected = collectionTypeButtons.filter(
                (b) => values[b.id]
              );
              !(selected.length === 1 && id === selected[0].id) &&
                setFieldValue(id, !values[id]);
            }}
            selectedIcon={<IcCheckmark style={{ fill: '#E21B70' }} />}
            disabled={!values.editable}
          />
        </Grid>
      </PaddedPaper>
    </Grid>
  );
};
